import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = {
  key: 0,
  class: "error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "login-card",
      shadow: "hover"
    }, {
      default: _withCtx(() => [
        _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "login-title" }, "Сменить пароль", -1)),
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          onSubmit: _withModifiers(_ctx.handleReset, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "username" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
                  placeholder: "Username",
                  "prefix-icon": "el-icon-user",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                  type: "password",
                  placeholder: "Введите старый пароль",
                  "prefix-icon": "el-icon-lock",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "newPassword" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.newPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.newPassword) = $event)),
                  type: "password",
                  placeholder: "Введите новый пароль",
                  "prefix-icon": "el-icon-lock",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "confirmNewPassword" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.confirmNewPassword,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.confirmNewPassword) = $event)),
                  type: "password",
                  placeholder: "Введите новый пароль еще раз",
                  "prefix-icon": "el-icon-lock",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                (!_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _ctx.handleReset,
                      block: ""
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("Сохранить новый пароль")
                      ])),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      disabled: ""
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("Загрузка...")
                      ])),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "onSubmit"]),
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}